<form [formGroup]="salaryForm" #ngForm="ngForm" class="form">
    <div class="header">{{'label.SalaryRange' | translate}}</div>

    <div class="salary-dropdown-row">
        <div class="salary-select">
            <p-select
                #dropdown
                [(ngModel)]="selectedSalaryOption"
                [dataKey]="'key'"
                [optionValue]="'key'"
                [styleClass]="'salaryOptionDropdown'"
                [options]="salaryOptions"
                formControlName="salaryRangeOption"
                optionLabel="name"
                [showClear]="selectedSalaryOption != 0"
                (ngModelChange)="onChangeSalaryRangeOption($event)"
                [placeholder]="''"
                [appendTo]="'body'">
                <ng-template let-item pTemplate="item">
                    <span class="dropdown-item">{{ item.name }}</span>
                </ng-template>

                <ng-template #selectedItem let-selectedOption>
                    <span *ngIf="selectedOption" [ngClass]="{'dropdown-value-grey' : selectedSalaryOption === 0, 'dropdown-value-green' : selectedSalaryOption !== 0}">{{ selectedOption?.name }}</span>
                </ng-template>

                <ng-template pTemplate="dropdownicon">
                    <svg-icon src="/assets/icons/arrow-down.svg" [svgStyle]="{'display':'flex', 'justify-content':'center', 'align-items':'center'}"></svg-icon>
                </ng-template>

                <ng-template #clearicon>
                    <svg-icon src="/assets/icons/close-small.svg" [svgStyle]="{'display':'flex', 'justify-content':'center', 'align-items':'center'}"></svg-icon>
                </ng-template>
            </p-select>
        </div>
        <span class="info-icon" matTooltip="{{ 'text.SalaryRange' | translate }}">
            <svg-icon src="/assets/icons/info-circle.svg" [svgStyle]="{'display':'flex', 'justify-content':'center', 'align-items':'center'}"></svg-icon>
        </span>
    </div>

    <div class="checkbox-container">
        <input (change)="onOnlySelectedSalary()" formControlName="onlySelectedSalary" type="checkbox" id="onlySelectedSalary">
        <label class="label" for="onlySelectedSalary">{{'label.OnlyWithTheIndicatedSalary' | translate}}</label>
        <span matTooltip="{{ 'text.SalaryFilterInfo' | translate }}">
         <svg-icon
           src="/assets/icons/info-circle.svg"
           [svgStyle]="{
             display: 'flex',
             'justify-content': 'center',
             'align-items': 'center'
           }"
         ></svg-icon>
        </span>
    </div>
</form>